/** Shared M2M setup copy for Auth0 connect surfaces (IMPL.3 / IMPL.3-rev). */
export const AUTH0_M2M_GUIDANCE = `To connect your Auth0 tenant, create a Machine-to-Machine (M2M) application
in the Auth0 Dashboard:

1. Go to your Auth0 Dashboard → Applications → Applications.
2. Create a new Application of type "Machine to Machine".
3. Authorize it for the Auth0 Management API.
4. Grant the following read-only scopes (11 required; 3 recommended for richer MFA + admin findings):
   Required:
   • read:tenant_settings, read:clients, read:connections, read:users, read:roles
   • read:rules, read:actions, read:logs, read:attack_protection
   • read:custom_domains, read:email_provider
   Recommended (optional — connection works without them):
   • read:guardian_factors (tenant MFA factor configuration)
   • read:authentication_methods (per-user MFA enrollment)
   • read:role_members (admin role holder enumeration)
5. From the application's Settings tab, copy:
   • Domain (the tenant domain, e.g. dev-xxxx.us.auth0.com)
   • Client ID
   • Client Secret

Paste these values above and click Test Connection. We only read your
configuration — no writes, no policy changes, no user data modifications.`;
